<div>
    <h2 style="margin: 5px 0 10px 0;">Create a New Consumer Category</h2>
    <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
        <div class="attribute-full-width">
            <mat-form-field>
                <input
                    matInput
                    required
                    placeholder="Consumer Category Name"
                    formControlName="name"
                >
                <mat-error *ngIf="form.controls['name'].invalid">Please enter a Name</mat-error>
            </mat-form-field>
        </div>
        <div class="attribute-full-width">
            <mat-form-field>
                <input
                    formControlName="id"
                    matInput
                    pattern="^[A-Z_0-9]*$"
                    placeholder="Consumer Category Tag"
                    required
                    (focusout)="findTagExists()"
                >
                <mat-error *ngIf="form.controls['id'].invalid && !form.controls['id'].value">
                    Please enter a Standard Tag
                </mat-error>
                <mat-error *ngIf="form.controls['id'].errors?.pattern && form.controls['id'].value">
                    Please enter a Valid Standard Tag
                </mat-error>
                <mat-error *ngIf="form.controls['id'].errors?.tagExists && form.controls['id'].touched">
                    Tag already exists! Create a new one.
                </mat-error>
            </mat-form-field>
        </div>
        <div class="attribute-full-width">
            <mat-form-field>
                <textarea
                    formControlName="description"
                    matInput
                    matTextareaAutosize
                    placeholder="Consumer Category Description"
                    required
                    maxlength="250"
                    >
                </textarea>
                <mat-error *ngIf="form.controls['description'].invalid">
                    Please enter a Description
                </mat-error>
            </mat-form-field>
        </div>
        <div  style="margin-top: 30px;" class="flex-center-center">
            <button
                class="button-color"
                mat-raised-button
                matTooltip="Cancel Creating Consumer Category"
                style="margin-right: 60px;"
                type="button"
                (click)="onNoClick()"
            >Cancel</button>
            <button
                class="button-color"
                [disabled]="false"
                mat-raised-button
                matTooltip="Submit Consumer Category"
                type="submit"
            >Save</button>
        </div>
    </form>
</div>
